import React, { useContext, useEffect } from 'react';
import { Form } from 'vindi-ds-components';
import useToggle from '@hooks/feature_toggles';
import { useNavigate, useParams } from 'react-router-dom';
import api from '@services/api';
import FormStructure from '../components/form_structure';
import { CreateProductProvider, ProductContext } from '../contexts/product_context';
import DiscardModal from '../components/discard_modal';

const ElementModal = (
  <DiscardModal
    cancel='Cancelar edição'
    subtitle='Você será redirecionado a tela de listagem de produtos.'
    title='Cancelar edição de produto?'
    confirm='Continuar edição'

  />
);

function EditProduct() {
  const toggle = useToggle('new_product_page');

  if (!toggle) {
    return null;
  }
  return (
    <CreateProductProvider>
      {ElementModal}
      <ProductForm />
    </CreateProductProvider>
  );
}

const handleSubmit = (values, navigate, id) => {
  /* eslint-disable camelcase */
  const { schema_type, ...productParams } = values;

  if (['flat', 'per_unit'].includes(schema_type)) {
    delete productParams.pricing_schema_attributes.pricing_ranges_attributes;
  }

  productParams.invoice = productParams.invoice ? 'always' : 'never';

  const params = { product: productParams };

  api.patch(`/admin/products/${id}`, params).then((response) => {
    navigate(response.data);
    window.location.reload();
  });
};

const ProductForm = () => {
  const { params, setEditProduct, fetched } = useContext(ProductContext);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setEditProduct(id);
  }, []);

  return (
    <>
      {fetched && (
      <Form
        onSubmit={(values) => handleSubmit(values, navigate, id)}
        initialValues={params}
      >
        <FormStructure headerTitle='Editar Produto' footerTitle='Editar produto' footerSubtitle='Cancelar' />
      </Form>
      )}
    </>
  );
};

export default EditProduct;
